var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBizztimeAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5008,
    cy: 17.1366,
    r: 3.65806,
    stroke: "#27B65B",
    strokeWidth: 1.07065
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.2861,
    y: 14.3496,
    width: 0.428678,
    height: 0.857357,
    rx: 0.214339,
    fill: "#27B65B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2861,
    y: 19.0649,
    width: 0.428678,
    height: 0.857357,
    rx: 0.214339,
    fill: "#27B65B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4307,
    y: 17.3506,
    width: 0.428678,
    height: 0.857357,
    rx: 0.214339,
    transform: "rotate(-90 17.4307 17.3506)",
    fill: "#27B65B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7148,
    y: 17.3506,
    width: 0.428678,
    height: 0.857357,
    rx: 0.214339,
    transform: "rotate(-90 12.7148 17.3506)",
    fill: "#27B65B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4707,
    y: 15.5356,
    width: 0.428678,
    height: 0.428678,
    rx: 0.214339,
    transform: "rotate(-90 13.4707 15.5356)",
    fill: "#27B65B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1016,
    y: 15.5356,
    width: 0.428678,
    height: 0.428678,
    rx: 0.214339,
    transform: "rotate(-90 17.1016 15.5356)",
    fill: "#27B65B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1016,
    y: 19.1655,
    width: 0.428678,
    height: 0.428678,
    rx: 0.214339,
    transform: "rotate(-90 17.1016 19.1655)",
    fill: "#27B65B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4707,
    y: 19.1655,
    width: 0.428678,
    height: 0.428678,
    rx: 0.214339,
    transform: "rotate(-90 13.4707 19.1655)",
    fill: "#27B65B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2861 17.0645V15.7999C15.3204 15.6971 15.4147 15.657 15.4576 15.6499C15.6519 15.6499 15.722 15.7642 15.722 15.8214V17.0074V17.0645L16.072 17.4075L16.9508 18.3006C17.0594 18.472 16.9342 18.5863 16.858 18.6221C16.7722 18.6507 16.6841 18.6102 16.6508 18.5863L15.3433 17.2789C15.3033 17.2446 15.2885 17.1884 15.2861 17.1646V17.0645Z",
    fill: "#27B65B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6416 4.41992C13.8273 4.44873 14.0498 4.51159 14.2461 4.62598C14.5117 4.78088 14.7412 5.03951 14.7412 5.4375V5.98926C14.7294 6.1548 14.6568 6.39525 14.4775 6.5957C14.2943 6.80053 14.0066 6.956 13.585 6.95605H7.31836V18.4717C7.31829 18.5437 7.26045 18.6024 7.18848 18.6025H4.89551C4.82344 18.6025 4.76472 18.5437 4.76465 18.4717V7.07617H2.24023C2.23219 7.07617 2.22372 7.0757 2.21582 7.07422C1.98444 7.03012 1.64458 6.89644 1.36035 6.6377C1.0726 6.37566 0.841918 5.98515 0.841797 5.4375V4.53223C0.841843 4.46015 0.900577 4.40142 0.972656 4.40137H13.4707L13.6416 4.41992ZM10.9961 15.9873C10.8961 16.3689 10.8418 16.7697 10.8418 17.1826C10.8418 17.6554 10.9131 18.1115 11.043 18.542H8.57617C8.50407 18.5419 8.44533 18.4832 8.44531 18.4111V16.1182C8.44536 16.0461 8.50409 15.9874 8.57617 15.9873H10.9961ZM14.5498 0.478516C14.8289 0.478516 15.2271 0.563942 15.6611 0.720703C16.0976 0.878349 16.5807 1.11204 17.0312 1.41699C17.928 2.02402 18.7236 2.93361 18.7236 4.10938V6.76465C18.7236 6.76969 18.7232 6.77526 18.7227 6.78027C18.6808 7.13519 18.5474 7.69802 18.2822 8.24805C18.0459 8.73816 17.6987 9.22813 17.208 9.54688C17.7713 9.94997 18.7236 10.9431 18.7236 12.5576V13.7148C18.0455 13.0929 17.1845 12.6675 16.2305 12.5283C16.1934 12.4342 16.1407 12.3279 16.0693 12.2148C15.9354 12.0027 15.7474 11.775 15.5195 11.5664C15.0612 11.1471 14.4575 10.8174 13.8262 10.8174H8.57617C8.50406 10.8173 8.44531 10.7586 8.44531 10.6865V8.39355C8.44552 8.32161 8.50419 8.26372 8.57617 8.26367H14.248C14.5528 8.26367 15.0521 8.05982 15.4795 7.68848C15.9032 7.32025 16.2294 6.80993 16.2295 6.22168V5.08691C16.1302 4.51497 15.5722 3.32591 14.1172 3.09375H2.4209C2.41208 3.09374 2.40317 3.0926 2.39453 3.09082C2.13888 3.03754 1.75773 2.90077 1.4375 2.66113C1.11602 2.42045 0.84191 2.06443 0.841797 1.5752V0.609375C0.841843 0.537294 0.900577 0.478569 0.972656 0.478516H14.5498Z",
    fill: "#264BA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizztimeAvailable);
export default __webpack_public_path__ + "static/media/BizztimeAvailable.487e2795d7b2d01c01403c57eecaf305.svg";
export { ForwardRef as ReactComponent };